import React, { useState } from "react";
import Modal from "react-modal";
import AddPostsUI from "./add-posts-ui";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "transparent",
  },
  overlay: {
    zIndex: 100,
    // backgroundColor: "#1E2A42",
  },
};

const AddPosts = ({
  modalIsOpen,
  afterOpenModal,
  closeModal,
  payload,
  loginUser,
  setPosts,
  setAllPosts,
}) => {
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Add Post">
        <AddPostsUI
          closeModal={closeModal}
          payload={payload}
          loginUser={loginUser}
          setPosts={setPosts}
          setAllPosts={setAllPosts}
        />
      </Modal>
    </div>
  );
};

export default AddPosts;
